import { createContext, useContext } from 'react';
import { AppType } from '@blocs.common';
import { ProfileViewFetcher, ProfileViewUpdater } from './types';

type ProfileViewContextType = {
  accountCountryCode: string;
  accountId: null | string | number;
  appType: AppType;
  fetcher: ProfileViewFetcher;
  hidePreviewButtons: boolean;
  isAdmin: boolean;
  isPlayableAgeSectionHidden: boolean;
  isPreview: boolean;
  isPublic: boolean;
  isRearrangeMedia: boolean;
  noExit?: boolean;
  onEditClick: (value?: any) => any;
  pickCount?: number;
  pickedBy?: { id: string; useName: number }[];
  presentationGuid?: string;
  presentationId?: number;
  showPicks?: boolean;
  showRepDetails: boolean;
  showSummary: boolean;
  showSummaryWithFolderCustomization?: boolean;
  showSummaryWithSubmissionDetails?: boolean;
  updater: ProfileViewUpdater;
  userName?: string;
  userNameModalToggle?: () => void;
};

const ProfileViewContext = createContext<ProfileViewContextType>({
  appType: AppType.Talent,
  fetcher: {
    profile: null,
    profileGuid: null,
    profileRoleId: null,
    isFolderCustomized: false,
    isUSCountry: false,
    refetch: null,
    artist: null,
    mediaData: null,
    submissionNote: null,
    submissionMedia: null,
    submissionRequestedMedia: null,
    submissionWorkingLocation: null,
  },
  isPreview: false,
  isAdmin: false,
  accountCountryCode: '',
  onEditClick: () => undefined,
  hidePreviewButtons: false,
  showRepDetails: false,
  showSummary: false,
  showSummaryWithSubmissionDetails: false,
  showSummaryWithFolderCustomization: false,
  accountId: null,
  updater: null,
  isRearrangeMedia: false,
  isPlayableAgeSectionHidden: false,
  isPublic: false,
  showPicks: false,
});

export default ProfileViewContext;

export const useProfileViewContext = () => useContext(ProfileViewContext);
